type Props = {
  priceToCharge?: string;
  stripeCardLabel: string;
};

export default function PaymentOnFileLabel({ priceToCharge, stripeCardLabel }: Props) {
  const [brand, last4] = stripeCardLabel ? stripeCardLabel.split(',') : ['', ''];
  return (
    <span>
      {priceToCharge ? `A charge of $${priceToCharge}` : `Charges`} will be made to your {brand}{' '}
      card on file •••• {last4}.
    </span>
  );
}
